import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { cn } from '../../lib/utils.ts'
import { VoiceAura } from './voiceAura.ts'

export function VoiceAuraCanvas(props: {
  active: boolean
  stream: MediaStream | null
  anchorRef: React.RefObject<HTMLElement | null>
  className?: string
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const auraRef = useRef<VoiceAura | null>(null)

  useLayoutEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    try {
      const aura = new VoiceAura(canvas, {
        anchor: props.anchorRef.current,
      })
      auraRef.current = aura
    } catch (e) {
      console.warn('VoiceAura: failed to initialize', e)
      auraRef.current = null
    }

    return () => {
      auraRef.current?.destroy()
      auraRef.current = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useLayoutEffect(() => {
    auraRef.current?.setAnchor(props.anchorRef.current)
  }, [props.anchorRef, props.active])

  useEffect(() => {
    const aura = auraRef.current
    if (!aura) return

    if (!props.active) {
      aura.stop()
      return
    }

    // Старт сразу, чтобы было видно появление. Поток микрофона
    // подключается, как только StreamService его отдаст.
    if (props.stream) {
      aura.start(props.stream)
    } else {
      aura.start()
    }
  }, [props.active, props.stream])

  return (
    <canvas
      ref={canvasRef}
      className={cn(
        'pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-230 w-full',
        props.className,
      )}
      aria-hidden
    />
  )
}
